import * as React from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import { Typography, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from "@mui/icons-material";

export default function InputBox(props) {
    const isPasswordField = props.tag === "sftp_password";
    const [showPassword, setShowPassword] = React.useState(false);
    return (
        <Paper
            component=""
            sx={{ 
                m: '10px 0', 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'flex-start', 
                width: props.width ? props.width : 397,
                boxShadow: 0, 
                border: "0.5px solid #CCCCCC",
                background: '#FAFAFA',
                borderRadius: '2px',
                padding: '7px 5px'
            }}
        >
            {
                props.innerLabel &&
                <Typography style={{
                    fontSize: '12px',
                    padding: '0 5px'
                }}>{props.innerLabel}</Typography>
            }
             <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                <InputBase
                    sx={{flex: 1, width: '100%', padding: '0 5px', fontSize:'14px', fontWeight:'400' }}
                    inputProps={{ 'aria-label': 'search' }}
                    type={
                        isPasswordField ?
                        (showPassword ? "text": "password")
                        : props.numeric ? "number" : "text"
                    }
                    id={props?.tag} 
                    name={props?.tag} 
                    label={props.label ? props.label : 'Placeholder'} 
                    placeholder={props.label && props.label} 
                    variant="outlined" 
                    defaultValue={props?.formikProps?.values[props.tag]} 
                    onChange={props?.formikProps?.handleChange}
                />
                {isPasswordField && (
                    <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{ marginRight: "1px" }}
                    >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                )}
            </div>
        </Paper>
    );
}
